import {useQuery} from "@tanstack/react-query";
import {REPORT_ENDPOINTS} from "../../services/network/endpoints";
import {ReportAPI} from "../../services/network/report-api";

/**
 * Хук для получения данных отчета
 * @param reportingWeek Номер недели
 * @param reportingYear Год
 */
export function useFetchAllReportsForExcel(
    reportingWeek?: number,
    reportingYear?: number,
) {

    const {data, error, isLoading} = useQuery({
        queryKey: [REPORT_ENDPOINTS.FETCH_ALL_EXCEL, reportingWeek, reportingYear],
        queryFn: () => {
            return ReportAPI.fetchAllReportsForExcel(
                reportingWeek || 0,
                reportingYear || 0
            );
        },
        enabled: Boolean(reportingWeek && reportingYear)
    });

    return {
        reportsData: data?.data,
        reportsError: error,
        reportsIsLoading: isLoading,
    };
}